//test
export const getCount = state => {
    return state.count
}

export const getUserAccess = state => {
    return JSON.parse(state.userAccess)
}
